export default "__VITE_ASSET__BiDmdP8N__"